import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import './i18n/config'
import App from './App'

Sentry.init({
  //@ts-ignore
  dsn: window.settings.SENTRY_DSN,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1.0,
  sendDefaultPii: true,
})

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(<App />)

export default root
